export default __webpack_public_path__ + "static/media/freeIcons.0948da9b.svg";